import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import {BreadcrumbItem, Breadcrumb, Col} from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ComputerUsePolicy = () =>{
    const handleLinkClick = () => {
        // Scroll to the top of the page
        window.scrollTo(0, 0);
      };
return (
<div className="RightsandResponsibilities">
    <section className="inner-banner banner-align">
        <img className="img-fluid" src="./assets/img/innerbanner/policies.jpg" alt="" />
    </section>
    <section className="research-box-area">
        <Container>
            <Breadcrumb>
                <BreadcrumbItem>
                    <Link as={Link} to="/">
                    Home
                    </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <Link as={Link} to="/About">
                    About
                    </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>Patron / User Policies</BreadcrumbItem>
            </Breadcrumb>
            <div className='information-content'>
                <h2>Patron / User Policies</h2>
            </div>
            <Row>
                <Col lg={5} sm={6}>
                <div className="floating-Side-wrap">
                    <div className="floating-Side">
                        <div className="right-tab-collab">
                            <div className="flex-column nav nav-pills">
                            <div className="nav-item">
                                    <Link as={Link} to="/BorrowingPolicies" 
                                    onClick={handleLinkClick} className='nav-link'>
                                    Borrowing Policies
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/ComputerUsePolicy" 
                                    onClick={handleLinkClick} className='nav-link active'>
                                    Computer Use Policy
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/DiscussionRoomsPolicy" 
                                    onClick={handleLinkClick} className='nav-link' >
                                    Discussion Rooms Policy
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/LibrarySpaces" 
                                    onClick={handleLinkClick} className='nav-link'>
                                    Library Spaces
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/FinesPenalty" 
                                    onClick={handleLinkClick} className='nav-link'>
                                    Fines & Penalty
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </Col>
                <Col lg={7} sm={6}>
                <div className="policyBox second">
                    <h5>Computer Use Policy</h5>
                    <p>Equipment and electronic resources are accessible during regular Library service hours. Staff are available to assist users in meeting their information needs with these computers.
                    </p>
                    <p>Observe copyright notices and warning screens and comply with copyright law. Digital content and materials on the Internet are protected under copyright law. Unauthorized distribution, reproduction, or transmission is illegal, and offenders are subject to prosecution.</p>
                    <p>Computers and networks are state assets. Please use them in a responsible, ethical, and lawful manner. Deliberately crashing, vandalizing, or otherwise compromising a computer or network, degrading performance; or unnecessarily consuming large amounts of system resources are serious offenses and may result in loss of library privileges and disciplinary action or criminal charges.</p>
                    <p>Respect other users of library computers and do not harass or interfere with them.</p>
                    <p>The library will report infractions of these policies to the Office of Student Affairs or the appropriate law enforcement agency. Any infraction could result in the loss of Library privileges and disciplinary action.</p>
                </div>
                </Col>
            </Row>
        </Container>
    </section>
</div>
);
}
export default ComputerUsePolicy;